import {
  CLOSE_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG,
  DECLARE_INADMISSIBILITY_QUOTE_DIALOG,
  DECLARE_INADMISSIBILITY_QUOTE_DIALOG_ERROR,
  DECLARE_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS,
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG,
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_ERROR,
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS,
  SHOW_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG
} from './QuoteDeclarationInadmissibilityDialog.actions'

const declarationInadmissibilityQuoteDialogState = {
  error: false,
  loading: false,
  open: false,
  showDeclarationInadmissibility: false,
  justificationsCriteria: [],
  quoteBid: null
}

/**
 * The declarationInadmissibilityQuoteDialog's reducer.
 */
const declarationInadmissibilityQuoteDialogReducer = (
  state = declarationInadmissibilityQuoteDialogState,
  { payload, type }
) => {
  switch (type) {
    case DECLARE_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS:
    case CLOSE_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG: {
      return {
        ...state,
        open: false,
        showDeclarationInadmissibility: false,
        quoteBid: null,
        justificationsCriteria: []
      }
    }
    case SHOW_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG: {
      return {
        ...state,
        error: false,
        open: true,
        showDeclarationInadmissibility: payload.showDeclarationInadmissibility,
        quoteBid: payload.quoteBid
      }
    }
    case DECLARE_INADMISSIBILITY_QUOTE_DIALOG:
    case GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG: {
      return { ...state, loading: true }
    }
    case GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS: {
      return {
        ...state,
        loading: false,
        justificationsCriteria: payload.justificationsCriteria
      }
    }
    case GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_ERROR: {
      return { ...state, loading: false, error: payload }
    }
    case DECLARE_INADMISSIBILITY_QUOTE_DIALOG_ERROR: {
      return { ...state, loading: false, error: payload }
    }
    default: {
      return state
    }
  }
}

export default declarationInadmissibilityQuoteDialogReducer
